<template>
  <div class="media-upload-item">
    <div class="sample" v-if="notStarted"
      @click="toggleSelect"
      :style="{ backgroundImage: isFront == '1' ? `url(${frontcover})` : `url(${backcover})`}"
      >
      <div class="tip">{{ tip }}</div>
    </div>
    <div
      class="preview"
      v-if="hasEnded"
      :style="{ backgroundImage: 'url(' + imagePreview + ')' }"
    ></div>
    <div class="progress-state" v-show="isUploading">
      <span>正在上传...</span>
    </div>
    <input @change="handleInputChange"  type="file" accept="image/*" ref="input" :style="{ display: 'none' }">
    <img class="close-btn" v-show="hasEnded" src="../images/close.png" @click="deletePic" />
    <z-actionsheet
      v-model="show"
      :actions="actions"
      cancel-text="取消"
      @select="onSelect"
    />
  </div>
</template>

<script>
import { Actionsheet } from '@zz-common/zz-ui';
import native from '@zz-common/native-adapter'

//  文件上传状态
const fileUploadState = {
  NOT_STARTED: 0,
  UPLOADING: 1,
  ENDED: 2
}
let maxRequestID = 1

export default {
  name: 'SecurePicUploadItem',
  components: {
    'z-actionsheet': Actionsheet
  },
  props: {
    type: {
      type: String,
      default: ''
    },
    tip: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      imagePreview: '',
      uploadState: fileUploadState.NOT_STARTED,
      frontcover: require('@assets/img/id_card_front_sample_new.png'),
      backcover: require('@assets/img/id_card_back_sample_new.png'), //new为包含文案的图片,如后续需要自定义文案可用非new的图片并用tip加文案
      show: false,
      actions: [
        { name: '开始拍照', value: 1 },
        { name: '从相册上传', value: 2 }
      ]
    }
  },
  computed: {
    notStarted() {
      return this.uploadState === fileUploadState.NOT_STARTED
    },
    isUploading() {
      return this.uploadState === fileUploadState.UPLOADING
    },
    hasEnded() {
      return this.uploadState === fileUploadState.ENDED
    },
    isFront() {
      if (this.type === 'front') {
        return '1'
      }
      return '0'
    }
  },
  methods: {
    uploadPic(params = {}) {
      if (this.uploadState === fileUploadState.UPLOADING) return

      let startTime = 0
      const requestID = maxRequestID++

      this.imagePreview = ''
      this.uploadState = fileUploadState.NOT_STARTED

      const invokeIDCardCamera = native.wrap('takePhotoOfIDCard')

      invokeIDCardCamera(
        {
          requestid: requestID,
          compressQuality: native.in('zz') ? '0.5' : '0.9',
          compressWidth: native.in('zz') ? 800 : '',
          type: '1',
          isFront: this.isFront,
          ...params
        },
        (res) => {
          if (!(res && res.code)) return

          if (res.code === '0') {
            if (Number(res.requestId) !== Number(requestID)) return

            if (this.uploadState !== fileUploadState.UPLOADING) {
              this.uploadState = fileUploadState.UPLOADING
              startTime = Date.now()
            }

            if (res.photoBase64) {
              this.imagePreview = res.photoBase64
            }
            if (res.photoString) {
              console.info(res.photoString)

              this.uploadState = fileUploadState.ENDED
              this.$emit('uploaded', res.photoString, startTime)
            }
          } else {
            this.imagePreview = ''
            this.uploadState = fileUploadState.NOT_STARTED
            console.warn(res.msg || '调起拍照失败')
            this.$toast(res.msg || '调起拍照失败')
          }
        }
      )
    },
    deletePic() {
      this.imagePreview = ''
      this.uploadState = fileUploadState.NOT_STARTED
      this.$emit('uploaded', '')
    },
    toggleSelect() {
      if (native.in('zlj')) {
        this.$refs.input.click()
      } else {
        this.show = !this.show
      }
    },
    onSelect(val) {
      this.show = !this.show
      if (val.value == 2) {
        this.uploadPic({ chooseAlbum: 1 })
      } else {
        this.uploadPic()
      }
    },
    async uploadzzos(file) {
      const data = new FormData()
      data.append('uploadfiles', file)
      const res = await fetch('https://dsyy.zhuanzhuan.com/uploadFileZZos', {
        method: 'POST',
        credentials: 'include',
        body: data
      }).then(response => {
        return response.json()
      })
        .catch(err => {
          console.warn(err)
          this.$toast('上传失败')
        })
      return res ? res.respData : undefined
    },
    fileToDataUrl(file) {
      const reader = new FileReader()
      reader.readAsDataURL(file)
      return new Promise((resolve) => {
        reader.onload = function() {
          resolve(this.result)
        }
      })
    },
    async handleInputChange(e) {
      const file = e.target.files[0]
      if (!file) return
      this.uploadState = fileUploadState.UPLOADING
      const base64 = await this.fileToDataUrl(file)
      const res = await this.uploadzzos(file)
      if (res == undefined) {
        this.uploadState = fileUploadState.NOT_STARTED
      } else {
        this.$emit('uploaded', res.fileId)
        this.imagePreview = base64
        this.uploadState = fileUploadState.ENDED
      }
    }
  }
}
</script>

<style scoped lang="less">
  @import 'MediaUploadItem.less';
</style>
